import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlay,
  faCircleXmark,
} from "@fortawesome/free-regular-svg-icons";
import { faVolumeHigh, faVolumeXmark } from "@fortawesome/free-solid-svg-icons";

const HorizontalCard = () => {
  const ref = useRef(null);
  const videoRef = useRef(null);

  const [imgError, setImgError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const principalImageUrl =
    "https://res.cloudinary.com/ddvpczzng/image/upload/f_auto,q_auto:best,w_800,h_600,c_fill,g_face/v1757446076/4.Principal_s0mp4n.jpg";

  const fallbackImage =
    "https://res.cloudinary.com/ddvpczzng/image/upload/v1716200000/school-building.jpg";

  return (
    <section
      id="horizontal-card-section"
      className="px-4 sm:px-6 md:px-10 lg:px-16 py-8 md:py-10 lg:py-12"
      style={{
        backgroundImage:
          "url('https://www.creativefabrica.com/wp-content/uploads/2021/03/08/Background-Triangular-Cyan-Blue-Graphics-9357255-1.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div
        ref={ref}
        className="mx-auto max-w-6xl bg-white rounded-xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-xl"
      >
        <div className="flex flex-col lg:flex-row">
          {/* LEFT: Image/Video */}
          <motion.div className="w-full lg:w-1/2 relative group overflow-hidden bg-black">
            {!isPlaying ? (
              <>
                <img
                  src={imgError ? fallbackImage : principalImageUrl}
                  alt="Principal"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />

                <button
                  type="button"
                  onClick={() => setIsPlaying(true)}
                  className="absolute inset-0 flex items-center justify-center"
                >
                  <FontAwesomeIcon
                    icon={faCirclePlay}
                    className="text-white text-6xl"
                  />
                </button>
              </>
            ) : (
              <>
                <video
                  ref={videoRef}
                  src="https://res.cloudinary.com/ddvpczzng/video/upload/v1765527219/P_wo6ffd.mp4"
                  controls
                  loop
                  playsInline
                  className="w-full h-full object-contain bg-black"
                />

                <button
                  type="button"
                  onClick={() => {
                    videoRef.current.pause();
                    setIsPlaying(false);
                  }}
                  className="absolute top-4 right-4"
                >
                  <FontAwesomeIcon
                    icon={faCircleXmark}
                    className="text-white text-4xl"
                  />
                </button>

                <button
                  type="button"
                  onClick={() => {
                    const next = !isMuted;
                    videoRef.current.muted = next;
                    videoRef.current.volume = next ? 0 : 1;
                    setIsMuted(next);
                  }}
                  className="absolute top-4 left-4"
                >
                  <FontAwesomeIcon
                    icon={isMuted ? faVolumeXmark : faVolumeHigh}
                    className="text-white text-2xl"
                  />
                </button>
              </>
            )}

            {!isPlaying && (
              <div className="absolute bottom-3 right-3 bg-cyan-600 text-white p-2 rounded-md shadow-md text-sm font-serif">
                Dr. Amudha Saravanan <br />
                <span className="opacity-75 text-xs">Principal</span>
              </div>
            )}
          </motion.div>

          {/* RIGHT CONTENT */}
          <motion.div className="w-full lg:w-1/2 p-6 sm:p-8 bg-white flex flex-col justify-center">
            <span className="inline-block px-3 py-1 text-[11px] sm:text-xs text-pink-800 bg-pink-100 rounded-full">
              Arise with vision! Shine with grace!
            </span>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold font-serif mt-3 leading-tight">
              About Our <span className="text-cyan-700">Humble Beginnings</span>
              <br /> and Enduring Legacy
            </h2>

            <div className="w-12 h-1 bg-yellow-500 mt-3"></div>

            <p className="mt-5 text-gray-700 leading-relaxed">
              Founded in{" "}
              <span className="font-semibold text-cyan-600">1989</span> under
              the visionary leadership of Mr. X. Williams, Secretary of the
              National Phonetary Society of India (NPSI), our institution began
              with humble beginnings in three small buildings.
            </p>

            <p className="mt-4 text-gray-700 leading-relaxed">
              Today, we proudly serve over{" "}
              <span className="font-semibold">1,500 students</span> across a
              modern campus, maintaining our commitment to academic excellence
              while embracing innovative teaching methodologies.
            </p>

            <div className="flex gap-2 mt-6">
              <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
              <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
              <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HorizontalCard;
